export default class PrintableImage {
    constructor() {
        this.printButtons = document.querySelectorAll('.print-button-js');

        this.printButtons.forEach(printButton => {
            printButton.addEventListener('click', () => {
                this.printImage(printButton.getAttribute('data-original-src'));
            });
        });
    }

    printImage(imageSrc) {
        // Extract filename from imageSrc
        const filename = imageSrc.substring(imageSrc.lastIndexOf('/') + 1);
        const temporaryWindow = window.open('', '_blank');
        temporaryWindow.document.write(`
            <html>
                <head>
                    <title>${filename}</title>
                    <style>
                        @media print {
                            body {
                                margin: 0;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                height: 100vh;
                            }
                            img {
                                max-width: 100%;
                                max-height: 100%;
                            }
                        }
                    </style>
                </head>
                <body>
                    <img src="${imageSrc}" alt="${filename}" />
                </body>
            </html>
        `);
        temporaryWindow.document.close();
        temporaryWindow.focus();
        temporaryWindow.onload = () => {
            temporaryWindow.print();
            temporaryWindow.close();
        };
    }
}
